export default __webpack_public_path__ + "static/media/discord.ed48553a.svg";